export default {
    tendiksData: [],
    tendiksPersekolahData: [],
    tendiksQueuePersekolahData: [],
    tenkelsPersekolahData: [],
    semuaTenkels: [],
    semuaMutens: [],
    mutensPersekolahData: []
}